var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPositionSizing = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 13H5v-1h7zM12 11H5v-1h7zM12 9H5V8h7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 3a2 2 0 0 1 .204 3.99L11 7H6l-.204-.01A2 2 0 0 1 6 3zM6 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 0a2 2 0 0 1 2 2v12a2 2 0 0 1-1.796 1.99L13 16H4l-.204-.01A2 2 0 0 1 2 14V2a2 2 0 0 1 2-2zM4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z",
  clipRule: "evenodd"
})));
export default SvgPositionSizing;